const editRecruitmentPoolValidation = {
  name: { type: 'string', required: true },
  requiredCandidateCheckTypes: { type: 'array', required: true, minSize: 1 },
};

export default editRecruitmentPoolValidation;
